import * as Modal from '@radix-ui/react-dialog';
import React, { useEffect, useState } from 'react';
import classNames from '@/lib/classNames';
import { hasLocaleSet } from '@/lib/hasLocaleSet';
import { LocaleSelectorContent } from './LocaleSelectorContent';

export const LocaleSelectorModal = () => {
    const [open, setOpen] = useState(!hasLocaleSet());
    const [mounted, setMounted] = useState(false);
    useEffect(() => {
        setMounted(true);
    }, []);

    return (
        <Modal.Root open={open} onOpenChange={setOpen} modal>
            {mounted ? (
                <Modal.Portal>
                    <div>
                        <Modal.DialogOverlay className="fixed inset-0 z-40 bg-black/70 data-[state=open]:animate-overlayShow" />
                        <Modal.Content className={classNames('z-50 fixed w-full left-[50%] translate-x-[-50%] bottom-10 outline-none animate-in px-4')}>
                            <div className="rounded-2xl bg-white p-4 text-primary shadow-xl relative">
                                <Modal.Close className="absolute top-2 right-2 inline-flex h-8 w-8 items-center justify-center rounded-full text-primary/70 hover:bg-black/5 hover:text-primary outline-none">
                                    x
                                </Modal.Close>
                                <LocaleSelectorContent>Change your travel destination in the main menu</LocaleSelectorContent>
                            </div>
                        </Modal.Content>
                    </div>
                </Modal.Portal>
            ) : null}
        </Modal.Root>
    );
};
